/* eslint-disable max-statements */
/* eslint-disable complexity */
"use strict";

const updateOrCreateHiddenInput = (form, inputName, value) => {
    const inputNameModified = `properties[_${inputName}]`;
    let input = form.querySelector(`input[name="${inputNameModified}"]`);
    if (!input) {
        input = document.createElement("input");
        input.type = "hidden";
        input.name = inputNameModified;
        input.classList.add("od-loyalty-input");
        form.appendChild(input);
    }
    input.value = value;
};

const handleVariantChange = (event) => {
    const form = event.target;
    if (!form) return;
    console.log(form);

    const buyButtonsBlock = form.closest(`[data-block-id="buy_buttons"]`);
    let loyaltyEarnEl = null;
    if (buyButtonsBlock) {
        loyaltyEarnEl = buyButtonsBlock.querySelector("[data-loyalty-earn]");
    }
    if (!loyaltyEarnEl) {
        const inputNameModified = `properties[_loyalty_earn]`;
        const existingInput = form.querySelector(
            `input[name="${inputNameModified}"]`
        );
        if (existingInput) {
            existingInput.parentNode.removeChild(existingInput);
        }
        return;
    }

    const loyaltyEarnValue = loyaltyEarnEl.getAttribute("data-loyalty-earn");
    if (!loyaltyEarnValue) return;

    updateOrCreateHiddenInput(form, "loyalty_earn", loyaltyEarnValue);
};

document.addEventListener("variant:change", handleVariantChange);
document.addEventListener("DOMContentLoaded", () => {
    document
        .querySelectorAll(
            `[data-block-id="buy_buttons"] form[is="product-form"]`
        )
        .forEach((form) => {
            handleVariantChange({ target: form });
        });
});
